/* eslint-disable max-len */
import { SvgProps } from './types'

export const HandGraphIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M26.9464 25.6902L34.403 21.071C34.447 21.0454 34.491 21.0197 34.535 20.9941C36.4963 19.9236 38.5199 22.3065 37.2368 24.1321C37.0352 24.4181 36.7823 24.671 36.478 24.8763L26.7411 31.9957C25.9163 32.6006 24.9045 32.9012 23.8816 32.8462L18.0674 32.5309C16.2784 32.4356 14.5847 33.3411 13.6719 34.8808"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8482 28.0107H25.1839C26.159 28.0107 26.9472 27.2225 26.9472 26.2474C26.9472 25.2722 26.159 24.484 25.1839 24.484H18.5631C18.1085 24.484 17.6796 24.2824 17.39 23.9378L17.1297 23.6262C16.3415 22.6877 15.2197 22.0901 14.0026 21.9618C12.4592 21.7969 10.9305 22.4017 9.91503 23.5749L5.77246 28.5093"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3088 38.5029L13.8228 36.5013C14.2701 35.911 14.1601 35.0715 13.5772 34.6133L5.4057 28.2088C4.80815 27.7395 3.94664 27.8532 3.48839 28.4581L2 30.423"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8652 20.536V8.17065H36.6603V18.5784"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.208 22.8933V11.4591H28.9995V21.6286"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.342 22.5452V15.6348H16.5469V21.9329"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.88965 20.7268V18.6335H13.6848V20.5362"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3504 5.26714V2.56165L27.5883 7.20645H23.1231L19.0429 11.2867H11.0693"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3508 2.56159L29.8359 2.50293"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
